module.exports = {
      id: "ebbf0d379437fea7b5864f3b4e626138water-local-source.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#ebbf0d379437fea7b5864f3b4e626138water-local-source.svg",
      toString: function () {
        return this.url;
      }
    }